import React, { useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col, notification } from 'antd'
import { formItemLayout } from '../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { updateEventFxn } from './actions'
import moment from 'moment'

const EditEventDrawer = (props) => {
  let {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    event,
    callback = null
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    if (visible && event) {
      setTimeout(() => {
        setFieldsValue({
          eventName: event.eventName || '',
          eventShortName: event.eventShortName || '',
          slugEvent: event.slugEvent || '',
          eventDate: event.eventDate ? moment(event.eventDate) : null
        })
      }, 100)
    }
  }, [visible, event, setFieldsValue])

  const inputSchema = {
    fields: [
      {
        label: 'Event Name',
        key: 'eventName',
        required: true,
        placeholder: 'Enter event name',
        type: 'text'
      },
      {
        label: 'Event Short Name',
        key: 'eventShortName',
        required: true,
        placeholder: 'Enter short name',
        type: 'text'
      },
      {
        label: 'Slug Event',
        key: 'slugEvent',
        required: true,
        placeholder: 'Enter Slug Event',
        type: 'text'
      },
      {
        label: 'Event Date',
        key: 'eventDate',
        required: true,
        placeholder: 'Select event date',
        type: 'date'
      }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (err) return notification.error({ message: err.message || 'Error' })

      let payload = {
        _id: event._id,
        eventName: valData.eventName,
        eventShortName: valData.eventShortName,
        slugEvent: valData.slugEvent,
        eventDate: valData.eventDate
      }

      let response = await dispatch(updateEventFxn(payload))
      if (response && response.success) {
        onClose()
        if (callback) callback()
      }
    })
  }

  return (
    <Drawer
      title={`Edit Event | Event ID: ${event ? event.eventName : 'N/A'}`}
      width={'35%'}
      visible={visible}
      maskClosable={false}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={24} key={key}>
                <GetEachFormFields
                  item={item}
                  getFieldDecorator={getFieldDecorator}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Update Event</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(EditEventDrawer)
